import { render, staticRenderFns } from "./PushSuccess.vue?vue&type=template&id=6bb1078f&"
import script from "./PushSuccess.vue?vue&type=script&lang=js&"
export * from "./PushSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports